import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnerPageTemplate from "@/components/partners/PartnerPageTemplate";
import { unidosUs } from "@/data/partners";

export const Route = createFileRoute("/partners/unidos-us")({
  head: () => seoHead("/partners/unidos-us"),
  component: () => <PartnerPageTemplate partner={unidosUs} />,
});
